import { Random } from '@framework/Random';
import type { FolderId } from 'balus-common';
const length = 20;
const prefix = 'f';
export const newFolderId = (): FolderId => Random.generateRandomID(length, prefix);
